import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface LoginState {
    value: {
        credentials: boolean,
        resetting: boolean
    };
}

const initialState: LoginState = {
    value: {
        credentials: false,
        resetting: false
    }
}

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        credentialsValidated: (state, action: PayloadAction<boolean>) => {
            state.value.credentials = action.payload;
        },
        resettingLogin: (state, action: PayloadAction<boolean>) => {
            state.value.resetting = action.payload;
        }, 
    },
})

export const {credentialsValidated, resettingLogin} = loginSlice.actions;

export default loginSlice.reducer;